// Module
var code = "<h3 class=\"interiorSubSectionHeading mt-0\">Benefits</h3> <ul> <li> Use Alec as a complete package or feature-by-feature to create a custom solution</li> <li> Alec features and services are always free-of-charge</li> <li> Receive unparalleled customer support</li> </ul> ";
// Exports
export default code;